import React from "react";
import Lottie from "react-lottie";
import "./Succes_lottie.css";
import * as animationData from "./Succes_lottie.json";

const Succes_lottie = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <>
      <section className="succes_main">
        <div className="succes_Lottie">
          <Lottie className="me-auto" options={defaultOptions} />
        </div>
      </section>
    </>
  );
};

export default Succes_lottie;
